import { render, staticRenderFns } from "./SendDataToEndpointDetailComponent.vue?vue&type=template&id=1c56aa66&scoped=true&"
import script from "./SendDataToEndpointDetailComponent.vue?vue&type=script&lang=js&"
export * from "./SendDataToEndpointDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./SendDataToEndpointDetailComponent.vue?vue&type=style&index=0&id=1c56aa66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56aa66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VRow,VSelect,VTextField})
